import { Timestamp } from '@firebase/firestore-types';
// import { Type } from "class-transformer";
import 'reflect-metadata';
import { LOCAL_STORAGE } from '../constants/local-storage.constants';
import { Type } from 'class-transformer';
import { Currency } from '../enums/payment-gateways.enum';
import { Vertical } from '../enums/business-type.enum';
import { StorageService } from '../services/storage.service';
import { CustomerAddress } from './customer.model';
import { Shipment, ShipmentValues } from './shipping.model';
import { SimpayxShipment } from './order-persist/order-detail.model';
import { AdditionalAttributes } from './catalogue.model';
// import { Vertical } from "../enums/business-type.enum";
// import { Currency } from "../enums/payment-gateways.enum";
// import { LocalStorageService } from "../services/local-storage.service";
// import { CustomerAddress } from "./customer.model";

//Storing it in firestore
export class SimpayxOrder {
  id!: string;
  orderId!: string;

  merchantId!: string;
  userId!: string;
  // resourceId: string;

  //Info
  orderNumber!: string;
  server: string = '';
  createdAt!: Timestamp;
  startedAt!: Timestamp;
  endedAt!: Timestamp;
  updatedAt!: Timestamp;
  statusUpdatedAt!: Timestamp;
  platformType: SimpayxPlatformType = SimpayxPlatformType.PICKUP;
  rejectReason!: string;
  specialInstruction: string = '';
  additionalServiceTime: number = 0;
  businessInfo!: BusinessInfo;
  totalTax: number = 0;
  totalDiscount: number = 0;
  isDelivery?: boolean;
  shipment?: Shipment;
  shipmentValues?: ShipmentValues;
  diners: SimpayxDiner[] = new Array<SimpayxDiner>();
  status: SimpayxOrderStatus = SimpayxOrderStatus.IN_PROGRESS;

  expandOrderCard!: boolean;

  @Type(() => SimpayxItem)
  items: SimpayxItem[] = new Array<SimpayxItem>();

  //billing info
  @Type(() => SimpayxCharge)
  charges: SimpayxCharge[] = new Array<SimpayxCharge>();

  discounts: SimpayxDiscount[] = new Array<SimpayxDiscount>();

  @Type(() => SimpayxTip)
  tip: SimpayxTip = new SimpayxTip();

  currency!: Currency;

  @Type(() => SimpayxPaymentInfo)
  paymentInfo: SimpayxPaymentInfo = new SimpayxPaymentInfo();
  // paymentStatus: SimpayxPaymentStatus = SimpayxPaymentStatus.YET_TO_START;
  taxableAmount!: number;
  shipmentAmount!: number;
  grandTotal!: number;

  constructor() {}

  getSimpayxShipment(): SimpayxShipment {
    return {
      selectedRates: {
        id: this.shipment?.selectedRates.id,
        shipmentId: this.shipment?.selectedRates.shipmentId,
        amount: this.shipment?.selectedRates.amount,
        currency: this.shipment?.selectedRates.currency,
        provider: this.shipment?.selectedRates.provider,
        providerImageUrl: this.shipment?.selectedRates.providerImageUrl,
        durationTerms: this.shipment?.selectedRates.durationTerms,
        attributes: this.shipment?.selectedRates.attributes
      },
      addressTo: {
        city: this.shipment?.addressTo?.city,
        country: this.shipment?.addressTo?.country,
        line1: this.shipment?.addressTo?.line1,
        state: this.shipment?.addressTo?.state,
        zip: this.shipment?.addressTo?.zip,
      }
    } as SimpayxShipment;
  }

  // platformType = PlatformType.PICKUP;
  getTaxableAmount() {
    let amount: number = 0;
    this.items.forEach((item: SimpayxItem) => {
      amount += item.getPrice();
    });
    this.taxableAmount = amount;
    return amount;
  }

  getShipmentCharge() {
    let amount: number = 0;
    if (this.shipment) {
      amount += Number(this.shipment.selectedRates.amount) * 100;
      this.shipmentAmount = amount;
    }

    return amount;
  }

  getTotalCharge() {
    let charge: number = 0;
    this.items.forEach((item) => {
      for (var tax of item.charges) {
        charge += (tax.percentage * item.getPrice()) / 100;
      }
    });
    return charge;
  }

  calculateAmountForCharge(charge: SimpayxCharge) {
    let amount = 0;
    this.items.forEach((item) => {
      if (
        item.charges.find(
          (tax) =>
            tax.description == charge.description &&
            tax.percentage == charge.percentage
        )
      ) {
        amount += (charge.percentage * item.getPrice()) / 100;
      }
    });

    return amount;
  }
  getTotalDiscount() {
    let discount: number = 0;
    this.discounts.forEach((simpayxDiscount: SimpayxDiscount) => {
      discount +=
        simpayxDiscount.type == SimpayxDiscountType.FLAT
          ? simpayxDiscount.value
          : (simpayxDiscount.percentage * this.getTaxableAmount()) / 100;
    });
    return Math.round(discount);
  }

  getTipValue() {
    if (this.tip?.description == TipType.FLAT) {
      return Number(this.tip?.percentage * 100);
    } else {
      let percentageTip = Math.round(
        (this.tip?.percentage * this.getTaxableAmount()) / 100
      );
      return percentageTip;
    }
  }

  getGrandTotal() {
    this.grandTotal =
      this.getTaxableAmount() +
      this.getTotalCharge() -
      this.getTotalDiscount() +
      this.getTipValue() +
      this.getShipmentCharge();
    return this.grandTotal;
  }
}

export class SimpayxCharge {
  description: string;
  percentage: number;
  constructor(description: string, percentage: number) {
    this.description = description;
    this.percentage = percentage;
  }
}

export class SimpayxDiscount {
  description!: string;
  percentage!: number;
  value!: number;
  type!: string;
  voucherId!: string;
}

export class BusinessInfo {
  constructor(
    public businessName: string,
    public businessId: string,
    public vertical: Vertical
  ) {}
}
export class SimpayxTip {
  description: TipType = TipType.PERCENTAGE;
  percentage: number = 0;
  value: number = 0;
}

export enum TipType {
  FLAT = 'FLAT',
  PERCENTAGE = 'PERCENTAGE',
}
export enum SimpayxPaymentStatus {
  YET_TO_START = 'YET_TO_START',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED',
  REFUND_INITIATED = 'REFUND INITIATED',
  REFUNDED = 'REFUNDED',
  CANCELLED = 'CANCELLED',
}

export enum SimpayxOrderStatus {
  YET_TO_START = 'YET_TO_START',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE_WITH_ORDER = 'DONE_WITH_ORDER',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  READY_FOR_PICKUP = 'READY_FOR_PICKUP',
  PICKED_UP = 'PICKED_UP',
  REJECTED = 'REJECTED',
  ACCEPTED = 'ACCEPTED',
  DISPATCHED = 'DISPATCHED',
  DELIVERED = 'DELIVERED'
}

export enum ShipmentStatus {
  PRE_TRANSIT = 'PRE_TRANSIT',
  TRANSIT = 'TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
  UNKNOWN = 'UNKNOWN',
}

export enum SimpayxPlatformType {
  DINE_IN = 'DINE_IN',
  TAKEOUT = 'TAKEOUT',
  PICKUP = 'PICKUP',
  DELIVERY = 'DELIVERY',
}

export enum SimpayxPaymentMode {
  ONLINE = 'Online (Credit / Debit card)',
  OFFLINE = 'Offline (Credit / Debit, Cash)',
}

export enum SimpayxDiscountType {
  FLAT = 'flat',
  PERCENTAGE = 'percentage',
}

export class SimpayxPaymentInfo {
  mode: SimpayxPaymentMode = SimpayxPaymentMode.ONLINE;
  transactionId!: string;
  paymentDate!: Timestamp;
  paymentMethodId!: string;
  paymentIntentId!: string;
  paymentStatus: SimpayxPaymentStatus = SimpayxPaymentStatus.YET_TO_START;
}

export class SimpayxItem {
  @Type(() => SimpayxCustomization)
  customizations: SimpayxCustomization[];
  constructor(
    public id: string,
    public catalogueId: string,
    public name: string,
    public description: string,
    public cataloguePrice: number,
    public offerPrice: number,
    public additionalAttributes: AdditionalAttributes,
    public quantity: number,
    public cookingInstruction: string,
    customizations: SimpayxCustomization[],
    public variant: SimpayxVariant,
    public addOns: SimpayxItem[],
    // need to check this
    // public status: OrderItemStatus = OrderItemStatus.ORDERED,
    // public orderedBy: SimpayxUser,
    public merchantComment: string,
    public addedAt: Timestamp,
    public charges: SimpayxCharge[]
  ) {
    this.customizations = customizations;
  }

  getPrice() {
    return (
      (this.offerPrice +
        this.getCustomizationsPrice() +
        (this.variant ? this.variant.price : 0)) *
      this.quantity
    );
  }

  private getCustomizationsPrice() {
    let customizationPrice: number = 0;
    this.customizations.forEach((customization: SimpayxCustomization) => {
      customizationPrice += customization.getPrice();
    });
    return customizationPrice;
  }
}

export class SimpayxCustomization {
  constructor(
    public name: string,
    public description: string,
    public isOptional: boolean,
    public options: SimpayxOptions[]
  ) {}
  getPrice() {
    let price: number = 0;
    this.options.forEach((option: SimpayxOptions) => {
      price += option.price;
    });
    return price;
  }
}

export class SimpayxOptions {
  constructor(public name: string, public price: number) {}
}

export class SimpayxVariant {
  constructor(
    public name: string,
    public description: string,
    public price: number
  ) {}
}

export class SimpayxDiner {
  public participantName: string = '';
  public phone: string = '';
  public sessionId: string = '';
  public journeyLocation: string = '';
  public feedback!: SimpayxFeedback;
  public email!: string;
  public address!: CustomerAddress;
}

export class SimpayxFeedback {
  constructor(
    public entityId: string,
    public rating: number,
    public comment: string,
    public entityType: string
  ) {}
}


